import React, { useContext, useEffect, useRef } from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import TickerMarquee from "react-fast-marquee";
import { useTicker } from "../services/system";
import { ComboTemplate } from "../controls";
import Icons from "../icons";
import { useHistory } from "react-router-dom";
import ContextMenu from "../controls/ContextMenu";
import { VisibilityOff } from "@material-ui/icons";
import {useUserSettings, useAddUserSetting, useUpdateUserSetting} from '../services/settings';
import SystemContext from "../SystemContext";

const AccessControl = require("../AccessControl");

const Ticker = (props) => {
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const menuItems = SystemData.menuItems;

  const queryClient = useQueryClient();
  const history = useHistory();

  const flags = useRef({
    settingsDone: false,
    loadedSetting: false,
  });

  const userInfo = AccessControl.getUserInfo();
  const userClass = userInfo?.userClass;

  const extraKeys = userClass !== "OPERATOR" ? [userInfo?.companyUuid] : [];
  const options={refetchInterval: 60*1000}
  const tickerData = useTicker({queryClient, extraKeys, options});
  const userSetting = useUserSettings({queryClient, extraKeys: ["TICKER", "PREFERENCES"]});
  const handleAddUserSetting = useAddUserSetting();
  const handleUpdateUserSetting = useUpdateUserSetting();

  if (userSetting && Array.isArray(userSetting.data)) {
    if (userSetting.data.length <= 0 && !flags.current.settingsDone) {
      flags.current.settingsDone = true;
      handleAddUserSetting.mutate({extraKeys:["TICKER", "PREFERENCES"], record: {
        module: 'TICKER', 
        area: 'PREFERENCES', 
        values: {
          hideEntries: [],
        }
      }});
    } else if (!flags.current.settingsDone) {
      flags.current.settingsDone = true;
    }
  }

  const handleClick = (tickerEntry) => {
    if (tickerEntry?.eventCode === "LAUNCH MENU") {
      const menuId = tickerEntry?.eventParams?.id;
      if (menuId) {
        const menuItem = __.find(menuItems, {id: menuId});
        if (menuItem) {
          const path = menuItem.path;
          history.push(path);
        }
      }
    }
  }

  const handleHide = (tickerData) => {
    const {tickerCode} = tickerData;
    const oldRecord = userSetting?.data[0] || {values: {hideEntries:[]}}
    const {values} = oldRecord;
    const hideEntries = __.uniq([...values.hideEntries, tickerCode]);

    handleUpdateUserSetting.mutate({extraKeys:["TICKER", "PREFERENCES"], record: {...oldRecord, values: {...values, hideEntries}}, oldRecord});
  }

  useEffect(()=> {
    const handleResetTicker = () => {
      const oldRecord = userSetting?.data[0] || {values: {hideEntries:[]}}
      const {values} = oldRecord;
      const hideEntries = [];
      handleUpdateUserSetting.mutate({extraKeys:["TICKER", "PREFERENCES"], record: {...oldRecord, values: {...values, hideEntries}}, oldRecord});
    }
    eventBus.bind("Ticker.reset", handleResetTicker);
    return () => {
      eventBus.unbind("Ticker.reset", handleResetTicker);
    }
  }, [eventBus, handleUpdateUserSetting]);

  return (
    <div>
      <TickerMarquee pauseOnHover gradientWidth={50} speed={80}>
        {tickerData.data?
          tickerData.data.map((tickerEntry, i) => {
            const hideEntry = userSetting && Array.isArray(userSetting.data) && userSetting.data.length > 0 && userSetting.data[0].values && Array.isArray(userSetting.data[0].values.hideEntries) && userSetting.data[0].values.hideEntries.indexOf(tickerEntry.tickerCode) > -1;
            if (hideEntry) {
              console.debug(`${tickerEntry.tickerCode} ticker entry is hidden`);
              return null;
            }
            return (
              <ContextMenu
                menuItems={[
                  {code: "HIDE", label: "Hide", icon: (<VisibilityOff/>), action: ()=>{handleHide(tickerEntry)}},
                ]}
              >
                <div key={tickerEntry.tickerCode} style={{padding: "16px 20px"}}  onClick={()=> {handleClick(tickerEntry)}}>
                  <div style={{display: "inline-block", fontSize: 20}}>
                    <Icons fontSize="inherit" style={{padding: "0px 5px"}} {...tickerEntry.icon?.props}>{tickerEntry.icon?.code}</Icons>
                  </div>
                  <div style={{display: "inline-block", verticleAlign: "middle", fontSize: 20, color: i%2 === 0?"grey":"black"}}>
                    <ComboTemplate group='TEMPLATES' subGroup='TICKER' code={tickerEntry.tickerCode} data={tickerEntry.tickerData}></ComboTemplate>
                  </div>
                </div>
              </ContextMenu>
            )
          })
        :null}
      </TickerMarquee>
    </div>
  )
}

export default Ticker;
